<template>
    <div class="business">
        <div class="business__inner">
            <div class="title-wrapper">
                <div class="section-symbol"></div>
                <p class="section-title is-lato">BUSINESS</p>
                <p class="section-desc" v-html="$t('main.business.desc')"></p>
            </div>
            <p class="section-label is-lato">BUSINESS</p>
            <div class="category" v-if="$resize && $mq.above(1024)">
                <router-link class="category__item"
                    v-for="(item, index) in category"
                    :key="index"
                    :to="'/business#' + item.title"
                    @click.native="$store.commit('setBusinessType', index + 1)">
                    <div class="video">
                        <video loop muted preload="auto" playsinline>
                            <source :src="item.path" type="video/mp4">
                        </video>
                    </div>
                    <p class="title is-lato" v-html="item.main"></p>
                    <p class="desc" v-html="$t(item.sub)"></p>
                </router-link>
            </div>
            <div class="category" v-else-if="$resize && $mq.above(320)">
                <agile :autoplay="true" :dots="true" v-if="slideLocale">
                    <router-link class="category__item slide"
                    v-for="(item, index) in category"
                    :key="index"
                    :to="'/business#' + item.title"
                    @click.native="$store.commit('setBusinessType', index + 1)">
                    <div :class="['image', 'is-' + (index + 1)]">
                    </div>
                    <p class="title is-lato" v-html="item.main"></p>
                    <p class="desc" v-html="$t(item.sub)"></p>
                </router-link>
                </agile>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Business',
    data: function () {
        return {
            category: [
                {
                    title: 'platform',
                    main: 'GLOBAL E-COMMERCE<br class="desktop-break">PLATFORM DEVELOPMENT',
                    sub: 'main.business.section01.desc',
                    path: require('../../assets/video/main-business-01.mp4')
                }, {
                    title: 'logistics',
                    main: 'GLOBAL E-COMMERCE<br class="desktop-break">LOGISTICS SERVICE',
                    sub: 'main.business.section02.desc',
                    path: require('../../assets/video/main-business-02.mp4')
                }, {
                    title: 'fulfillment',
                    main: 'GLOBAL FULFILLMENT<br class="desktop-break">SERVICE',
                    sub: 'main.business.section03.desc',
                    path: require('../../assets/video/main-business-03.mp4')
                }, {
                    title: 'contactcenter',
                    main: 'GLOBAL CONTACT CENTER<br class="desktop-break">SERVICE',
                    sub: 'main.business.section04.desc',
                    path: require('../../assets/video/main-business-04.mp4')
                }
            ],
            slideLocale: ''
        }
    },
    methods: {
        hoverPlay: function () {
            var categoryItem = document.getElementsByClassName('category__item')
            Array.prototype.forEach.call(categoryItem, function (el) {
                el.addEventListener('mouseover', function () {
                    el.children[0].children[0].play()
                })
                el.addEventListener('mouseleave', function () {
                    el.children[0].children[0].pause()
                })
            })
        },
        setSlideLocale: function (val) {
            this.slideLocale = false
            var self = this
            setTimeout(function () {
                self.slideLocale = val
            }, 5)
        }
    },
    computed: {
        getLocale () {
            return this.$store.getters.getLocale
        }
    },
    watch: {
        getLocale: function (val, oldVal) {
            this.setSlideLocale(val)
        }
    },
    mounted: function () {
        this.hoverPlay()
        this.slideLocale = this.$store.getters.getLocale
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
@import '@/assets/style/main.scss';
@include over-desktop {
    .business {
        overflow: hidden;
        position: relative;
        // background: #f8f8f8;
        padding: 170px 0 100px;
        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            width: 100%;
            height: 100%;
            background: #f8f8f8;
        }

        &__inner {
            position: relative;
            width: 1200px;
            margin: 0 auto;

            .section-symbol {
                margin: 0 auto;
            }
            .section-title {
                margin-top: 12px;
                text-align: center;
            }
            .section-desc {
                margin-top: 12px;
                text-align: center;
            }
            .section-label {
                position: absolute;
                top: 134px;
                right: 0;
                font-weight: 700;
                font-size: 16px;
                color: #d2d2d2;
                letter-spacing: 13px;
                transform: rotate(90deg);
                transform-origin: top right;

                &::before {
                    content: '';
                    display: block;
                    position: absolute;
                    top: 50%;
                    right: -70px;
                    width: 60px;
                    height: 1px;
                    background: #d2d2d2;
                    opacity: 0.3;
                }
            }
            .category {
                width: 1200px;
                padding-top: 50px;
                margin: 60px auto 0;

                &::after {
                    content: '';
                    display: block;
                    clear: both;
                }
                &__item {
                    float: left;
                    display: block;
                    width: 285px;
                    margin-left: 20px;
                    transition: transform 250ms;

                    &:first-child {
                        margin-left: 0;
                    }
                    &:hover {
                        transform: translateY(-10px);
                    }
                    &:nth-child(2n-1) {
                        transform: translateY(-50px);
                        &:hover {
                            transform: translateY(-60px);
                        }
                    }
                    .video {
                        position: relative;
                        overflow: hidden;
                        width: 100%;
                        height: 285px;
                        background: #aaa;
                        &::before {
                            content: '';
                            display: block;
                            position: absolute;
                            z-index: 2;
                            top: 30px;
                            left: 30px;
                            width: 70px;
                            height: 56px;
                            opacity: 1;
                            transition: opacity 250ms;
                        }
                        &::after {
                            @include gradient;
                            content: '';
                            display: block;
                            position: absolute;
                            top: 0;
                            left: 0;
                            z-index: 1;
                            width: 100%;
                            height: 100%;
                            opacity: 0.5;
                            transition: opacity 250ms;
                        }
                        video {
                            position: absolute;
                            left: 50%;
                            width: auto;
                            height: 100%;
                            transform: translateX(-50%);
                        }
                    }
                    &:hover .video {
                        &::before,
                        &::after {
                            opacity: 0;
                        }
                    }
                    @for $i from 1 to 5 {
                        &:nth-child(#{$i}) {
                            .video::before {
                                background: url(../../assets/image/main/business_icon0#{$i}.png) no-repeat center;
                            }
                        }
                    }
                    .title {
                        margin-top: 20px;
                        color: #555;
                        font-weight: 700;
                        font-size: 16px;
                        line-height: 20px;
                    }
                    .desc {
                        margin-top: 10px;
                        color: #999;
                        font-size: 15px;
                        line-height: 20px;
                        letter-spacing: -1px;
                    }
                }
            }
        }
    }
    .section02 > .business {
        .title-wrapper {
            opacity: 0;
            transform: translateY(-40px);
            transition: opacity 1000ms, transform 1000ms;
        }
        .section-label {
            opacity: 0;
            transform: rotate(90deg) translateX(100px);
            transition: opacity 1000ms 750ms, transform 1000ms 750ms;
        }
        .category {
            opacity: 0;
            transform: translateY(40px);
            transition: opacity 750ms 500ms, transform 750ms 500ms;
        }
    }
    .section02.is-active > .business {
        .title-wrapper {
            opacity: 1;
            transform: translateY(0);
        }
        .section-label {
            opacity: 1;
            transform: rotate(90deg) translateX(0);
        }
        .category {
            opacity: 1;
            transform: translateY(0);
        }
    }
}
@include desktop-small {
    .business {
        padding-top: 120px;
        &__inner {
            width: 1024px;
            .section-label {
                right: 28px;
            }
            .category {
                width: 1024px;
                padding: 50px 28px 0;
                &__item {
                    width: 230px;
                    margin-left: 16px;
                    .video {
                        height: 230px;
                    }
                }
            }
        }
    }
}
@include under-tablet {
    .business {
        padding: 14vw 0;
        background: #f8f8f8;
        &__inner {
            overflow: hidden;
            position: static;
            width: 100%;
            .section-title {
                margin-top: 3.4vw;
            }
            .section-desc {
                margin-top: 3.4vw;
            }
            .section-label {
                display: none;
            }
            .category {
                width: 100%;
                margin-top: 8vw;

                &__item {
                    .image {
                        position: relative;
                        width: 100vw;
                        height: 60vw;

                        &::before {
                            content: '';
                            display: block;
                            position: absolute;
                            z-index: 1;
                            top: 8vw;
                            left: 8vw;
                            width: 16vw;
                            height: 13vw;
                        }
                    }
                    @for $i from 1 to 5 {
                        &:nth-child(#{$i + 1}) {
                            .image {
                                background: url(../../assets/image/main/business-0#{$i}-g.jpg) no-repeat center;
                                background-size: auto 100%;
                            }
                            .image::before {
                                background: url(../../assets/image/main/icon0#{$i}.svg) no-repeat center;
                                background-size: auto 100%;
                                background-origin: top left;
                            }
                        }
                    }
                    &:nth-child(1) {
                        .image {
                            background: url(../../assets/image/main/business-04-g.jpg) no-repeat center;
                            background-size: auto 100%;
                        }
                        .image::before {
                            background: url(../../assets/image/main/icon04.svg) no-repeat center;
                            background-size: auto 100%;
                            background-origin: top left;
                        }
                    }
                    &:nth-child(6) {
                        .image {
                            background: url(../../assets/image/main/business-01-g.jpg) no-repeat center;
                            background-size: auto 100%;
                        }
                        .image::before {
                            background: url(../../assets/image/main/icon01.svg) no-repeat center;
                            background-size: auto 100%;
                            background-origin: top left;
                        }
                    }
                    .title {
                        margin-top: 7.2vw;
                        color: #555;
                        font-weight: 700;
                        font-size: 3.2vw;
                        text-align: center;
                    }
                    .desc {
                        min-height: 18vw;
                        margin-top: 3.2vw;
                        color: #999;
                        font-size: 3.2vw;
                        line-height: 5vw;
                        text-align: center;
                    }
                }
            }
        }
    }
    .section02 > .business {
        .title-wrapper {
            opacity: 0;
            transform: translateY(4vh);
            transition: opacity 1000ms, transform 1000ms;
        }
        .category {
            opacity: 0;
            transform: translateY(2vh);
            transition: opacity 750ms 500ms, transform 750ms 500ms;
        }
    }
    .section02.is-active > .business {
        .title-wrapper {
            opacity: 1;
            transform: translateY(0);
        }
        .category {
            opacity: 1;
            transform: translateY(0);
        }
    }
}
@include mobile {
    .business {
        &__inner {
            .category {
                &__item {
                    .title {
                        margin-top: 7.2vw;
                        font-size: 3.8vw;
                    }
                    .desc {
                        min-height: 18vw;
                        margin-top: 3.2vw;
                        font-size: 3.8vw;
                    }
                }
            }
        }
    }
}
</style>

<style>
.category .agile__dots {
    align-items: center;
    justify-content: center;
    margin-top: 2vw;
}
.category .agile__dot {
    background: #bfbfbf;
    margin-left: 2vw;
    width: 2vw;
    height: 2vw;
    border-radius: 50%;
}
.category .agile__dot--current {
    background: #ea7a94;
}
.category .agile__dot:first-child {
    margin-left: 0;
}
.category .agile__arrow {
    display: none;
}
@media (min-width: 320px) and (max-width: 767px) {
    .category .agile__dots {
        align-items: center;
        justify-content: center;
        margin-top: 4vw;
    }
    .category .agile__dot {
        margin-left: 2.4vw;
        width: 2.4vw;
        height: 2.4vw;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/main/Business.vue